import styled from "styled-components";
import { ContentCard, PageContainer, PageHeader, PrimaryButton } from "../empresas/Empresas";

export default function Perfis() {
  return (
    <PageContainer>
      <PageHeader>
        <div>
      <h1>Perfis</h1>
      <p>Cadastro e gerenciamento dos perfis de acesso.</p>
        </div>

        <PrimaryButton type="button">
          Nova Clínica
        </PrimaryButton>
      </PageHeader>

      <ContentCard>
        <h2>Clínicas cadastradas</h2>
        <p>A listagem das clínicas será exibida aqui.</p>
      </ContentCard>
    </PageContainer>
  );
}